<template>
  <div class="option-menu-item" @click="$emit('click')">
    <slot>
      <i :class="icon" v-if="icon" />
      <span v-text="title" />
    </slot>
  </div>
</template>

<script>
export default {
  name: "OptionMenuItem",
  props: {
    icon: String,
    title: String,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" >
.option-menu-item {
  line-height: 25px;
  padding: 5px 14px;
  cursor: pointer;
  i + span {
    margin-left: 8px;
  }
  span,
  i {
    color: #888888 !important;
  }
  &:hover {
    span,
    i {
      color: #0078a3 !important;
    }
  }
  &:first-child {
    padding-bottom: 5px;
  }
  &:last-child {
    padding-top: 5px;
  }
}
</style>
